module.exports = __webpack_public_path__ + "img/tarj-myfip.0e0f971d.jpg";